mutation UpdateImpactMeasurementCategory(
  $impactMeasurementCategoryId: ID!
  $impactMeasurementCategoryInput: ImpactMeasurementCategoryInput!
) {
  updateImpactMeasurementCategory(
    input: {
      impactMeasurementCategoryId: $impactMeasurementCategoryId
      impactMeasurementCategoryInput: $impactMeasurementCategoryInput
    }
  ) {
    impactMeasurementCategory {
      id
    }
  }
}
